// export default {
//   '401': '认证fail，无法访问系统资源',
//   '403': '当前操作没有权限',
//   '404': '访问资源不存在',
//   'default': '系统未知错误，请反馈给管理员'
// }
export default {
  '401': 'Authentication failed, and the system resources cannot be accessed. Procedure',
  '403': 'The current operation has no permission',
  '404': 'The access resource does not exist',
  'default': 'The system has an unknown error. Please report the error to the administrator'
}